export const GET_CATEGORIES = "GET_CATEGORIES"
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS"
export const GET_CATEGORIES_FAILED = "GET_CATEGORIES_FAILED"

export const UPDATE_CATEGORY_ORDER = "UPDATE_CATEGORY_ORDER"
export const UPDATE_CATEGORY_ORDER_SUCCESS = "UPDATE_CATEGORY_ORDER_SUCCESS"
export const UPDATE_CATEGORY_ORDER_FAILED = "UPDATE_CATEGORY_ORDER_FAILED"

export const OPEN_EDIT_CATEGORY_MODAL = "OPEN_EDIT_CATEGORY_MODAL"
export const HIDE_EDIT_CATEGORY_MODAL = "HIDE_EDIT_CATEGORY_MODAL"
export const EDIT_CATEGORY = "EDIT_CATEGORY"
export const EDIT_CATEGORY_SUCCESS = "EDIT_CATEGORY_SUCCESS"
export const EDIT_CATEGORY_FAILED = "EDIT_CATEGORY_FAILED"

export const OPEN_DELETE_CATEGORY_MODAL = "OPEN_DELETE_CATEGORY_MODAL"
export const HIDE_DELETE_CATEGORY_MODAL = "HIDE_DELETE_CATEGORY_MODAL"
export const DELETE_CATEGORY = "DELETE_CATEGORY"
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS"
export const DELETE_CATEGORY_FAILED = "DELETE_CATEGORY_FAILED"

export const CREATE_CATEGORY = "CREATE_CATEGORY"
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS"
export const CREATE_CATEGORY_FAILED = "CREATE_CATEGORY_FAILED"

export const OPEN_CATEGORY_ERROR_MODAL = "OPEN_CATEGORY_ERROR_MODAL"
export const HIDE_CATEGORY_ERROR_MODAL = "HIDE_CATEGORY_ERROR_MODAL"

export const GET_CATEGORY = "GET_CATEGORY"
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS"
export const GET_CATEGORY_FAILED = "GET_CATEGORY_FAILED"
export const RESET_CATEGORY = "RESET_CATEGORY"

export const UPDATE_MULTIPLE_CATEGORIES_ORDER =
  "UPDATE_MULTIPLE_CATEGORIES_ORDER"
export const UPDATE_MULTIPLE_CATEGORIES_ORDER_SUCCESS =
  "UPDATE_MULTIPLE_CATEGORIES_ORDER_SUCCESS"
export const UPDATE_MULTIPLE_CATEGORIES_ORDER_FAILED =
  "UPDATE_MULTIPLE_CATEGORIES_ORDER_FAILED"
